export default __webpack_public_path__ + "static/media/Nairobi.54be159d.png";